import util from "@utils/util";
import ReHeader from "../../../basic/us_header";
import Content from "./index-material-us";
var globalParameter = util.getQueryData(window.location.search);
export default {
  name: "usIndexmaterial",
  components: {
    "website-header": ReHeader,
    Content: Content
  },
  data: function data() {
    return {
      countryCode: globalParameter.countryCode || "us"
    };
  },
  methods: {}
};